/**
 * Created by hp on 2017/6/12.
 */
import React, {Component} from 'react';
import {filterHTML, replaceAllmatching} from "../../utils";

export default class LectureDescription extends Component {
    componentDidMount() {
        // iframe
        let iframeEles = document.querySelectorAll('.lecture-content iframe');
        let screenWidth = window.innerWidth || screen.width;
        if (screenWidth > 480) {
            screenWidth = 480;
        }
        let iframeHeight = Math.ceil((screenWidth - 15 *2) * 9 / 16);
        if (iframeEles.length > 0) {
            for (let i = 0; i < iframeEles.length; i++) {
                iframeEles[i].height = iframeHeight + 'px';
            }
        }
    }

    render() {
        const {description} = this.props;
        const newDescription = replaceAllmatching('img.weike.fm','img2.lizhiweike.com',description)
        return(
            <article className="lecture-content">
                <div className="lecture-tab-title">课程介绍</div>
                <section dangerouslySetInnerHTML={{__html: filterHTML(newDescription)}}/>
            </article>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/lecture/LectureDescription.js